/**
 * DB-backed RBAC catalog (GET /api/permissions/catalog). Server caches in Redis (~30 min).
 */
import api from '@/lib/axios'

export type RbacCatalogSnapshot = {
  schemaVersion: 2
  generatedAt: string
  keys: string[]
  features: Array<{
    scope: 'platform' | 'organization' | 'branch'
    feature: string
    displayName: string
    featureId: string
    key: string
    permissions: {
      view?: string
      create?: string
      edit?: string
      delete?: string
    }
  }>
}

import { API_ENDPOINTS } from '@/config/api.constants'

const CATALOG_PATH = API_ENDPOINTS.PLATFORM.PERMISSIONS.CATALOG

export async function fetchRbacCatalogSnapshot(): Promise<RbacCatalogSnapshot> {
  const response = await api.get(CATALOG_PATH)
  const data = response.data?.data ?? response.data
  if (!data?.keys || !Array.isArray(data.keys)) {
    throw new Error('Invalid RBAC catalog response')
  }
  return data as RbacCatalogSnapshot
}
